import { Col, Form, Image, Row, Space, Spin, Table } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Button from 'components/Button';
import { useMutation, useQuery } from 'react-query';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { IProduct } from 'interface/product.interface';
import { ColumnsType } from 'antd/es/table';
import CreateCartPage from '../../../../pages/Cart/PreOrder/CreatePreOrder';
import { DownloadOutlined } from '@ant-design/icons';
import formatDate from 'utils/formatDate';
import CartApi from 'apis/CartApi';
import { openNotificationWithIcon } from 'utils/notification';
import pageTitleStore from 'store/pageTitleStore';

interface Iparam {
  id?: string;
}
export default function CreateCartReview(): JSX.Element {
  const history = useHistory();
  const { id } = useParams<Iparam>();
  const location = useLocation<{
    cart: any;
    listProductSelected: IProduct[];
  }>();

  const setStep = useCategoryManagementStore((state) => state.setStep);
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const listProductSelected: IProduct[] = location.state?.listProductSelected;

  const cart = location.state?.cart;

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const pagination = { page: page, page_size: page_size };

  const columns: ColumnsType<IProduct> = [
    {
      title: 'STT',
      dataIndex: 'ma_mau',
      width: 80,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'ma_mau',
      width: 177,
    },

    {
      title: 'Tên mẫu',
      dataIndex: 'ten_mau',
      width: 261,
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      render: (record: any) => {
        return (
          <Image
            className="border border-solid border-neutral-90 rounded-lg"
            src={record}
            width={50}
            height={50}
          />
        );
      },
      width: 100,
    },
    {
      title: 'Bộ phận phát triển',
      dataIndex: 'nhan_hang',
      width: 261,
    },
    {
      title: 'Ngành hàng',
      width: 115,
      dataIndex: 'nganh_hang',
    },
    {
      title: 'Dòng hàng Xman',
      dataIndex: 'dong_hang',
      width: 148,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chung_loai',
      width: 148,
    },
    {
      title: 'Kết luận đánh giá 3 tiêu chí',
      dataIndex: 'kldg_3tc',
      width: 148,
    },
    {
      title: 'Doanh thu 6 tháng gần nhất',
      dataIndex: 'doanhthu_6th',
      width: 148,
      align: 'right',
    },
    {
      title: 'Tổng SL tồn hiện tại',
      dataIndex: 'tongsl_ton',
      width: 112,
      align: 'right',
    },
    {
      title: 'Tổng giá trị tồn hiện tại',
      dataIndex: 'tong_giatri',
      width: 112,
      align: 'right',
    },
    {
      title: 'Giá trung bình',
      dataIndex: 'gia_tb',
      width: 112,
      align: 'right',
    },
    {
      title: 'Cửa hàng',
      dataIndex: 'cua_hang',
      width: 112,
    },
    {
      title: 'Số lượng phân bổ',
      dataIndex: 'so_luong_phan_bo',
      width: 112,
    },
    {
      title: 'Vốn tồn phân bổ',
      dataIndex: 'von_ton_phan_bo',
      width: 112,
    },
    {
      fixed: 'right',
      align: 'center',
      width: 0,
    },
  ];

  useEffect(() => {
    setStep(1);
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
    setTitle('Kiểm tra thông tin');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/preorder">Giỏ hàng</a>{' '}
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/preorder">Đăng ký mẫu</a>
          </p>
        ),
      },
      { title: <a href="">Kiểm tra thông tin</a> },
    ]);
  }, []);

  const {
    mutate: PostApproveProductToStore,
    isLoading: isPostApproveProductToStoreLoading,
  } = useMutation(
    () =>
      CartApi.sendApproveProductToStore({
        cart_code: cart?.cart_code,
        data: getApproveProductToStore(),
      }),
    {
      onSuccess: (response: any) => {
        if (response.status === 'failure') {
          openNotificationWithIcon(
            'error',
            'Tạo giỏ hàng thất bại',
            `${response.error}`
          );
        } else {
          openNotificationWithIcon('success', 'Tạo giỏ hàng thành công');

          setTimeout(() => {
            history.push('/preorder');
          }, 500);
        }
      },
      onError: (error: any) => {
        openNotificationWithIcon(
          'error',
          'Tạo giỏ hàng thất bại',
          `${error.message}`
        );
      },
    }
  );

  function generateExcel() {
    const data = [];

    // create title
    const headerRow = columns.map((column) => {
      if (column.dataIndex === 'isSelected') {
        return 'Đã chọn';
      } else {
        return column.title;
      }
    });
    data.push(headerRow);

    // create data
    listProductSelected.forEach((product) => {
      const rowData = columns.map((column) => {
        if (column.dataIndex === 'isSelected') {
          return true;
        }
        return product[column.dataIndex];
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `mau_san_pham.xlsx`);
  }

  const getApproveProductToStore = () => {
    const cartData: any[] = [];
    listProductSelected.map((product: any) => {
      cartData.push({
        pro_code: product.ma_mau,
        // cua_hang: product.cua_hang.split(';'),
        cua_hang:
          product.cua_hang == null || product.cua_hang == undefined
            ? null
            : product.cua_hang.split(';'),
      });
    });

    return cartData;
  };

  return (
    <Spin spinning={isPostApproveProductToStoreLoading}>
      <CreateCartPage>
        <Content>
          <div className="text-xl font-bold mb-6">1. Thông tin giỏ hàng</div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Tên giỏ hàng
                </Col>
                <Col className="" span={12}>
                  : <strong>{cart?.cart_name}</strong>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Loại giỏ hàng
                </Col>
                <Col className="" span={12}>
                  : {cart?.cart_type_name}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Thời gian hiện hành
                </Col>
                <Col className="" span={12}>
                  : {formatDate(cart?.release_date)}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={3}>
              Mô tả
            </Col>
            <Col className="" span={20}>
              : {cart?.description}
            </Col>
          </Row>

          <div className="my-4 border-2 border-dashed border-neutral-90"></div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Người tạo
                </Col>
                <Col className="" span={12}>
                  : {cart?.created_by}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Email
                </Col>
                <Col className="" span={12}>
                  : {cart?.email}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Khối phát hành
                </Col>
                <Col className="" span={12}>
                  : {cart?.division}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Công ty phát hành
                </Col>
                <Col className="" span={12}>
                  : {cart?.company}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={3}>
              Đơn vị phát hành
            </Col>
            <Col className="" span={20}>
              : {cart?.department_name}
            </Col>
          </Row>

          <div className="my-4 border-2 border-dashed border-neutral-90"></div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Số lượng phân bổ
                </Col>
                <Col className="" span={18}>
                  :{' '}
                  {listProductSelected.reduce(
                    (sum, obj) => sum + (obj.so_luong_phan_bo ?? 0),
                    0
                  )}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={8}>
                  CH được đăng ký
                </Col>
                <Col className="" span={16}>
                  : 0
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={24}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={3}>
                  Giá trị vốn tồn đăng ký
                </Col>
                <Col className="" span={21}>
                  : 0
                </Col>
              </Row>
            </Col>
          </Row>
        </Content>

        <Content>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            align="middle"
            className="mb-3"
          >
            <Col span={12}>
              <div className="text-xl font-bold">Danh sách sản phẩm</div>
            </Col>
            <Col span={12}>
              <Row justify="end" align="middle">
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    customClass="fix-border-radius"
                    onClick={generateExcel}
                  >
                    <DownloadOutlined />
                    Tải file excel
                  </Button>
                </Space>
              </Row>
            </Col>
          </Row>
          <Table
            rowKey={(record) => record.id}
            className="customTable"
            size="small"
            columns={columns}
            dataSource={listProductSelected || []}
            scroll={{ x: 970 }}
            pagination={{
              className: 'flex items-center',
              total: listProductSelected?.length,
            }}
          />
        </Content>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
          style={{ marginTop: '20px', marginRight: '2px' }}
        >
          <Form.Item className="mr-2">
            <Button
              onClick={() => (window.location.href = '/preorder-create-order')}
              bgColor={'bg-white'}
              color={'text-primary-50'}
              border={'border-primary-50'}
              customClass="hidden"
            >
              Trở lại
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              onClick={() => {
                PostApproveProductToStore();
              }}
              border={'border-primary-50'}
            >
              Đăng ký mẫu
            </Button>
          </Form.Item>
        </Row>
      </CreateCartPage>
    </Spin>
  );
}
